export enum RelayTypes {
    RELAY = 'Relay',
    IRDA = 'Irda',
    VOLTAGE_OUTPUT = 'VoltageOutput'
}

export enum RelayPathIdTypes {
    RELAY = 'relay',
    IRDA = 'irda',
    VOLTAGE_OUTPUT = 'analog'
}